import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Auth from "./router/auth";
import Layout from "./router/layout";
import VideoBluegecko from "./component/pages/landingpage/Video";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { LoaderCircle } from "lucide-react";

const App = () => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);

  // Wait for MSAL to finish initializing
  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      // Small delay to ensure state is fully settled
      const timer = setTimeout(() => {
        setIsInitializing(false);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [inProgress]);

  // Show loading spinner while MSAL is initializing
  if (isInitializing || inProgress !== InteractionStatus.None) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
        <LoaderCircle className="animate-spin text-blue-900" size={50} />
      </div>
    );
  }

  return (
    <Router>
      <ToastContainer position="top-right" autoClose={1500} />
      <Routes>
        <Route path="/" element={<VideoBluegecko />} />
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <Layout isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
            ) : (
              <Auth />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;